import { UserDTO } from "app/back-office/shared/models/users/user.model";
import { ActiveChannelDTO } from "./channel.model";

export class Shop {
  name: string;
  id: number;
  externalId: string;
  uri: string;
  primaryColor: string;
  secondaryColor: string;
  backgroundImageUrl: string;
  vatRate: number;
  discount: number;
  currency: string;
  preOrderActiveFrom: Date;
  preOrderActiveTo: Date;
  reOrderActiveFrom: Date;
  reOrderActiveTo: Date;
  maxCustomDeliveryDate: string;
  backgroundImageMediaId: number;
  mainVideoUrlMediaId: number;
  footerText: string;
  defaultCustomizationRequestsDesignerUser: UserDTO;
  customizationsCustomerSupportEmail: string;
  customizationsCustomerSupportPhone: string;
  imageLogoMediaId: number;
  imageLogoMediaUrl: string;
  imageLogoSmallMediaId: number;
  imageLogoSmallMediaUrl: string;
  faviconMediaId: number;
  faviconMediaUrl: string;
  homeVideoUri?: string;
  checked?: string;
  kustomMinimumOrderedQtyForCrProduct?: number;
  mailNotifications: string;
  mailSender: string;
  activatedStoreChannels: ActiveChannelDTO[];
  defaultStockLimitByProductAndPalette: number;
  minimumOrderTotal: number;
  computedDeliveryDateDaysDelta: number;
  supportsSplitDelivery: boolean;
  supportsIntegrationDynamicsFields: boolean;
  enableKustomApp: boolean;
  maxCartNameLength: boolean;
  daysBeforeNotification?: number;
  daysBeforeDeletion?: number;
  constructor(s?: Partial<Shop>) {
    if (s) {
      Object.assign(<Shop>this, s);
      if (!this.backgroundImageUrl) {
        this.backgroundImageUrl = 'assets/shop/images/home-default-image.png';
      }
    }
  }
}